import api from "./axiosInstance";

export const getArtists = async () => {
  const res = await api.get("api/v1/artists/");
  return res.data;
};

export const getArtistById = async (id) => {
  const res = await api.get(`api/v1/artists/${id}/`);
  return res.data;
};

export const getArtistCalendar = async (artistId, year, month) => {
  const res = await api.get(
    `api/v1/artists/${artistId}/calendar/`,
    {
      params: { year, month },
    }
  );
  return res.data;
};


export const updateArtist = async (id, payload) => {
  const res = await api.patch(`api/v1/artists/${id}/`, payload);
  return res.data;
};
